import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import client, { apiErr } from "@/lib/api";

export default function JobNumberRedirect() {
  const { n } = useParams();
  const nav = useNavigate();
  const [err, setErr] = useState("");
  useEffect(() => {
    client.get(`/jobs/by-number/${n}`)
      .then(({ data }) => nav(`/jobs/${data.id}`, { replace: true }))
      .catch((e) => setErr(apiErr(e.response?.data?.detail)));
  }, [n, nav]);
  return <div className="p-8 text-slate-500" data-testid="job-number-redirect">{err || `Opening job #${n}…`}</div>;
}
